module.exports = __webpack_public_path__ + "img/particle_motion_00100.d142cbf3.png";